import * as actionTypes from '../actionTypes/NewPaymentActionTypes';
import * as shippingActionTypes from '../actionTypes/NewShippingActionTypes';

const addCreditCard = (value) => ({
    type: actionTypes.ADD_CREDIT_CARD,
    value,
});

const addBnplToOrder = (value) => ({
    type: actionTypes.ADD_BNPL_TO_ORDER,
    value,
});

/**
 * Update credit card info
 */
const updateUserPayment = (value) => ({
    type: actionTypes.UPDATE_USER_PAYMENT,
    value,
});

const setAddressStandNotRequired = (value = false) => ({
    type: actionTypes.SET_ADDRESS_STAND_NOT_REQUIRED,
    value,
});

const showBillingAddressForm = (value = false) => ({
    type: actionTypes.SHOW_BILLING_ADDRESS_FORM,
    value,
});

const toggleNewCreditCardForm = (value, orderDetailsInfo, options) => ({
    type: actionTypes.TOGGLE_NEW_CREDIT_CARD_FORM,
    value,
    orderDetailsInfo,
    options,
});

const initEmptyCreditCardForm = (orderDetailsInfo, options, userDefaultAddress = {}) => ({
    type: actionTypes.INIT_EMPTY_CREDIT_CARD_FORM,
    orderDetailsInfo,
    options,
    userDefaultAddress,
});

const initGuestUpdateCreditCardForm = (orderDetailsInfo, options) => ({
    type: actionTypes.INIT_GUEST_UPDATE_CREDIT_CARD_FORM,
    orderDetailsInfo,
    options,
});

const initRegisterUpdateCreditCardForm = (userPaymentInfo, orderDetailsInfo, options) => ({
    type: actionTypes.INIT_REGISTER_UPDATE_CREDIT_CARD_FORM,
    userPaymentInfo,
    orderDetailsInfo,
    options,
});

const initNewPayment = (initiatedFromAdjustment) => ({
    type: actionTypes.INIT_NEW_PAYMENT,
    initiatedFromAdjustment,
});

const updatePaymentMethodType = (methodType) => ({
    type: actionTypes.UPDATE_PAYMENT_METHOD_TYPE,
    methodType,
});

const updateCreditCardForm = (attribute, newValue, options) => ({
    type: actionTypes.UPDATE_CREDIT_CARD_FORM,
    attribute,
    newValue,
    options,
});

const updateCreditCardFormFieldError = (attribute, options) => ({
    type: actionTypes.UPDATE_CREDIT_CARD_FORM_FIELD_ERROR,
    attribute,
    options,
});

const updateCreditCardFormError = (errorInfo) => ({
    type: actionTypes.UPDATE_CREDIT_CARD_FORM_ERROR,
    errorInfo,
});

const updateProfilePaymentList = (paymentFromProfile, orderDetailsInfo, options) => ({
    type: actionTypes.UPDATE_PROFILE_PAYMENT_LIST,
    paymentFromProfile,
    orderDetailsInfo,
    options,
});

const setCreditCardSavedToProfile = (value) => ({
    type: actionTypes.SET_SAVE_CREDIT_CARD_TO_PROFILE,
    value,
});

const setDefaultPreferenceCreditCardSavedToProfile = (value) => ({
    type: actionTypes.SET_DEFAULT_PREFERENCE_CREDIT_CARD_TO_PROFILE,
    value,
});

const deleteUserPayment = (paymentId) => ({
    type: actionTypes.DELETE_USER_PAYMENT,
    paymentId,
});

const selectUserPayment = (paymentId, orderPaymentInfo, options) => ({
    type: actionTypes.SELECT_USER_PAYMENT,
    paymentId,
    orderPaymentInfo,
    options,
});

const setDeleteConfirmationInfo = (show, paymentId) => ({
    type: actionTypes.SET_DELETE_CONFIRMATIONMODAL_INFO,
    show,
    paymentId,
});

const hideRegisterUserUpdateCreditCardForm = () => ({
    type: actionTypes.HIDE_REGISTER_UPDATE_CREDIT_CARD_FORM,
});

const hideNewCreditCardForm = () => ({
    type: actionTypes.HIDE_NEW_CREDIT_CARD_FORM,
});

const getGiftCardList = (orderDetailsInfo, options) => ({
    type: actionTypes.GET_GIFT_CARD_LIST,
    orderDetailsInfo,
    options,
});

const removeGiftCard = (removeGiftCardId) => ({
    type: actionTypes.REMOVE_GIFTCARD_REQUEST,
    removeGiftCardId,
});

const showHideGiftCardForm = (showHideGiftCardFormFlag) => ({
    type: actionTypes.SHOW_HIDE_GIFTCARD_FORM,
    showHideGiftCardFormFlag,
});

const getAppGiftCards = () => ({
    type: actionTypes.GET_APP_GIFT_CARDS,
});

const giftCardFormChangeValue = (attribute, newValue) => ({
    type: actionTypes.GIFT_CARD_FORM_CHANGE_VALUE,
    attribute,
    newValue,
});

const giftCardFormFieldError = (attribute) => ({
    type: actionTypes.GIFT_CARD_FORM_FIELD_ERROR,
    attribute,
});

const giftCardFormError = (errorInfo) => ({
    type: actionTypes.GIFT_CARD_FORM_ERROR,
    errorInfo,
});

const giftCardFormSubmit = () => ({
    type: actionTypes.GIFT_CARD_FORM_SUBMIT,
});

const nativeAppWalletGCSubmit = (payload = {}) => ({
    type: actionTypes.APP_WALLET_GIFT_CARD_FORM_SUBMIT,
    payload,
});

const getSpecialDiscountInfo = (orderDetailsInfo) => ({
    type: actionTypes.GET_SPECIAL_DISCOUNT_INFO,
    orderDetailsInfo,
});

const initBillingAddressForm = (address, context) => ({
    type: shippingActionTypes.EDIT_BILLING_ADDRESS,
    address,
    context,
});

const updatePaypalContactInfo = () => ({
    type: actionTypes.UPDATE_PAYPAL_CONTACT_INFO,
});

const pollGCBalanceInfo = () => ({
    type: actionTypes.POLL_GC_BALANCE_INFO,
});

const stopPollingGetGCBalanceInfo = () => ({
    type: actionTypes.STOP_POLLING_GET_GC_BALANCE_INFO,
    payload: {},
});

export {
    addCreditCard,
    addBnplToOrder,
    updateUserPayment,
    setAddressStandNotRequired,
    showBillingAddressForm,
    toggleNewCreditCardForm,
    initEmptyCreditCardForm,
    initGuestUpdateCreditCardForm,
    initRegisterUpdateCreditCardForm,
    updateCreditCardForm,
    updateCreditCardFormFieldError,
    updateCreditCardFormError,
    initNewPayment,
    updatePaymentMethodType,
    updateProfilePaymentList,
    setCreditCardSavedToProfile,
    setDefaultPreferenceCreditCardSavedToProfile,
    setDeleteConfirmationInfo,
    deleteUserPayment,
    selectUserPayment,
    hideRegisterUserUpdateCreditCardForm,
    hideNewCreditCardForm,
    getGiftCardList,
    removeGiftCard,
    showHideGiftCardForm,
    giftCardFormFieldError,
    giftCardFormChangeValue,
    giftCardFormError,
    giftCardFormSubmit,
    nativeAppWalletGCSubmit,
    getSpecialDiscountInfo,
    initBillingAddressForm,
    updatePaypalContactInfo,
    getAppGiftCards,
    pollGCBalanceInfo,
    stopPollingGetGCBalanceInfo,
};
